import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.scss']
})
export class RegistroComponent implements OnInit {

  comprador = false;
  distribuidor = false;
  usuario: string;
  imageSrc: any;
  image: any;
  nameRut: string;
  correo: string;
  constructor(private route: ActivatedRoute,
              private authSvc: AuthService,
              private router: Router) { }

  newUserForm = new FormGroup({
    nombre: new FormControl('', Validators.required),
    cedula: new FormControl('', [Validators.required, Validators.minLength(8)]),
    email: new FormControl('', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]),
    telefono: new FormControl('', [Validators.required, Validators.minLength(8)]),
    contrasena: new FormControl('', [Validators.required, Validators.minLength(8)]),
    fechaCreacion: new FormControl(new Date().getTime()),
    estado: new FormControl('Pendiente', Validators.required),
    rut: new FormControl('', Validators.required),
    tipo: new FormControl('Distribuidor', Validators.required),
    direccion: new FormControl('', Validators.required)
  });

  newUserFormBuyer = new FormGroup({
    cedula: new FormControl('', [Validators.required, Validators.minLength(8)]),
    nombre: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]),
    telefono: new FormControl('', [Validators.required, Validators.minLength(8)]),
    contrasena: new FormControl('', [Validators.required, Validators.minLength(8)]),
    fechaCreacion: new FormControl(new Date().getTime()),
    tipo: new FormControl('Comprador', Validators.required),
    direccion: new FormControl('', Validators.required)
  });

  get nombreNoValido() {
    return this.newUserForm.get('nombre').invalid && this.newUserForm.get('nombre').touched;
  }
  get emailNoValido() {
    return this.newUserForm.get('email').invalid && this.newUserForm.get('email').touched;
  }
  get telefonoNoValido() {
    return this.newUserForm.get('telefono').invalid && this.newUserForm.get('telefono').touched;
  }
  get contrasenaNoValido() {
    return this.newUserForm.get('contrasena').invalid && this.newUserForm.get('contrasena').touched;
  }
  get cedulaNoValido() {
    return this.newUserForm.get('cedula').invalid && this.newUserForm.get('cedula').touched;
  }
  get direccionNoValido() {
    return this.newUserForm.get('direccion').invalid && this.newUserForm.get('direccion').touched;
  }

  get buyerNombreNoValido() {
    return this.newUserFormBuyer.get('nombre').invalid && this.newUserFormBuyer.get('nombre').touched;
  }
  get buyerCedulaNoValido() {
    return this.newUserFormBuyer.get('cedula').invalid && this.newUserFormBuyer.get('cedula').touched;
  }
  get buyerEmailNoValido() {
    return this.newUserFormBuyer.get('email').invalid && this.newUserFormBuyer.get('email').touched;
  }
  get buyerTelefonoNoValido() {
    return this.newUserFormBuyer.get('telefono').invalid && this.newUserFormBuyer.get('telefono').touched;
  }
  get buyerContrasenaNoValido() {
    return this.newUserFormBuyer.get('contrasena').invalid && this.newUserFormBuyer.get('contrasena').touched;
  }
  get buyerDireccionNoValido() {
    return this.newUserFormBuyer.get('direccion').invalid && this.newUserFormBuyer.get('direccion').touched;
  }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id === 'Comprador') {
      this.comprador = true;
      this.usuario = 'Cliente';
    }
    if (id === 'Distribuidor') {
      this.distribuidor = true;
      this.usuario = 'Distribuidor';
    }
  }

  addNewUser(usuario: any){
    if (this.newUserForm.invalid){
      Swal.fire({
        title: 'Error...',
        text: 'Debe ingresar la información requerida',
        icon: 'error',
        allowOutsideClick: false,
        showCloseButton: true
      });
      return Object.values( this.newUserForm.controls ).forEach( control => {
        if ( control instanceof FormGroup ) {
          // tslint:disable-next-line: no-shadowed-variable
          Object.values( control.controls ).forEach( control => control.markAsTouched() );
        } else {
          control.markAsTouched();
        }
      });
    } else {
      Swal.fire({
        title: 'Está seguro?',
        text: 'Se va a solicitar registro de distribuidor en Su Pedido',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, aceptar!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.correo = usuario.email;
          this.nameRut = usuario.nombre + usuario.cedula;
          usuario.tipo = this.usuario;
          console.log(usuario.email, usuario.contrasena);
          const user = this.authSvc.register(this.correo, usuario.contrasena);
          if (user) {
            user.then(usr => {
              const idUser = usr.user.uid;
              this.authSvc.filterProd(usuario, this.image, usuario.cedula, idUser);
            });
          }
          Swal.fire(
            'Enviado!',
            'Su solicitud fué generada correctamente.',
            'success'
          );
          this.router.navigate([`home`]);
        }
      });
    }
  }

  addNewUserBuyer(usuario: any){
    if (this.newUserFormBuyer.invalid){
      Swal.fire({
        title: 'Error...',
        text: 'Debe ingresar la información requerida',
        icon: 'error',
        allowOutsideClick: false,
        showCloseButton: true
      });
      return Object.values( this.newUserFormBuyer.controls ).forEach( control => {
        if ( control instanceof FormGroup ) {
          // tslint:disable-next-line: no-shadowed-variable
          Object.values( control.controls ).forEach( control => control.markAsTouched() );
        } else {
          control.markAsTouched();
        }
      });
    } else {
      Swal.fire({
        title: 'Está seguro?',
        text: 'Se va a solicitar registro de cliente en Su Pedido',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, aceptar!'
      }).then((result) => {
        if (result.isConfirmed) {
          usuario.tipo = this.usuario;
          usuario.estado = 'Activo';
          this.correo = usuario.email;
          usuario.rut = 'N/A';
          // console.log(usuario);
          const user = this.authSvc.register(this.correo, usuario.contrasena);
          if (user) {
            user.then(usr => {
              const idUser = usr.user.uid;
              this.authSvc.registrarComprador(usuario, idUser);
            });
          }
          Swal.fire(
            'Enviado!',
            'Su solicitud fué generada correctamente.',
            'success'
          );
          this.router.navigate([`home`]);
        }
      });
    }
  }

  handleImage(event: any){
    this.image = event.target.files[0];
    const reader = new FileReader();
    reader.onload = e => {
      this.imageSrc = reader.result;
    };
    reader.readAsDataURL(this.image);
  }

}
